export class Pattern {
  public static EMAIL_PATTERN = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,63})$';
  public static CONTACT_NO_PATTERN = '^[0-9]*$';
  public static STRING_PATTERN = '^[a-zA-Z_ ]+$';
  // Product/warehouse titles: allow letters, digits, spaces and common title punctuation
  // (e.g. "Tee 2024"). Kept separate from STRING_PATTERN so person-name/city fields that
  // share STRING_PATTERN keep rejecting digits. (WI-1417 defect #1)
  public static PRODUCT_TITLE_PATTERN = "^[a-zA-Z0-9 _.,'&/()-]+$";
  public static TIN_PATTERN = '[a-zA-Z0-9\s]*';
  public static LINK_PATTERN = '^[A-Za-z][A-Za-z\\d.+-]*:\/*(?:\\w+(?::\\w+)?@)?[^\\s\/]+(?::\\d+)?(?:\/[\\w#!:.?+=&%@\\-\/]*)?$';
  // No leading '-' — retail price and dimensions must be non-negative. (WI-1417 defect #2)
  public static CURRENCY_PATTERN = '^[0-9]\\d*(\\.\\d{1,2})?$';
  public static NUMBER_PATTERN = '^[0-9]*$';
  public static HOSTNAME_PATTERN = '^(?!-)[A-Za-z0-9-]+([\\-\\.]{1}[a-z0-9]+)*\\.[A-Za-z]{2,6}$';
  public static PERCENTAGE_PATTERN = '(^100(\\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?$)';
  public static ALPHANUMERIC_PATTERN: '/^[a-zA-Z0-9\s]+$/';
}

